export class PipeModel {
    _id: string;
    id: number;
    name: string;
    description: string;
    code: string;
    pipeGroupId: number;
    pipeMaterialGroupId: number;
    waterFillingAllowed: boolean;
    insulationAllowed: boolean;

    constructor(_id = null,
        id = null,
        name = '',
        description = '',
        code = '',
        pipeGroupId = null,
        pipeMaterialGroupId = null,
        waterFillingAllowed = true,
        insulationAllowed = true
    ) {
            this._id = _id;
            this.id = id;
            this.name = name;
            this.description = description;
            this.code = code;
            this.pipeGroupId = pipeGroupId;
            this.pipeMaterialGroupId = pipeMaterialGroupId;
            this.waterFillingAllowed = waterFillingAllowed;
            this.insulationAllowed = insulationAllowed;
    }
}
